<template>
  <div class="cksq-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.orderType" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brand_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="排产时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.schedule_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="库存包数"
                    width="90"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#F56C6C" v-if="scope.row.packcount>0">{{scope.row.packcount}}</span>
                      <span style="font-weight: 400;color:#909399" v-if="scope.row.packcount<=0">0</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="总报价"
                    width="130"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.amount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="余款"
                    width="130"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.is_orver===1">已结清</el-tag>
                      <span style="font-weight: 500;color:#F56C6C" v-if="scope.row.is_orver===0">{{scope.row.balance}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <!--<el-button v-if="scope.row.is_orver===0" size="mini" icon="el-icon-money" @click.stop="subsist(scope.row)">代为扣款</el-button>-->
                      <el-button size="mini" icon="el-icon-shopping-cart-full" @click.stop="applyOut(scope.row)">申请出库</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="订单代为扣款"
      :visible.sync="editVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules" v-loading="offerinfoLoading" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="报价详情" prop="offerdetail">
          <el-card shadow="hover" style="font-size: 12px;color:#606266">
            <div>
              <span style="color:#99a9bf">报价员：</span>
              <span>{{editForm.offername}}</span>
              <span style="color:#99a9bf;margin-left: 20px">报价时间：</span>
              <span>{{editForm.offertime}}</span>
            </div>
            <div style="">
              <span style="color:#99a9bf">报价单：</span>
              <span><el-button type="text" @click="downOffer" icon="el-icon-download" title="点击下载报价单">{{editForm.offerfile}}</el-button></span>
            </div>
            <div>
              <span style="color:#99a9bf">总报价：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.amount}}</span>元
              <s v-if="offerinfo.amount!==offerinfo.totalprice" style="margin-left: 10px;color:#999;">{{offerinfo.totalprice}}</s>
              <el-tag type="danger" :disable-transitions="true" size="mini" style="margin-left: 10px" v-if="offerinfo.discount>0">{{offerinfo.discount}} 折</el-tag>
            </div>
            <div v-if="offerinfo.factorycom>0||offerinfo.designcom>0">
              <span style="color:#99a9bf">设计承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.designcom}}</span>元
              <span style="color:#99a9bf;margin-left: 20px">工厂承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.factorycom}}</span>元
              <span style="color:#99a9bf;margin-left: 20px">客户承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.clientcom}}</span>元
            </div>
            <div>
              <span style="color:#99a9bf">已收款：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.paidfor}}</span>元
              <span style="color:#99a9bf;margin-left: 20px">余款：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.balance}}</span>元
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="账户余额" v-if="offerinfo.balance>0">
          <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{offerinfo.accamount}}</span>元
          <span style="color:#99a9bf">（{{offerinfo.accname}}）</span>
        </el-form-item>
        <el-form-item label="扣款金额" prop="money" v-if="offerinfo.balance>0">
          <el-input v-model="editForm.money" :disabled="true" style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="扣款验证" prop="dedutel" v-if="offerinfo.balance>0">
          <el-select v-model="editForm.dedutel" style="width: 220px" placeholder="请选择">
            <el-option
              v-for="item in DealerTelList"
              :key="item.dtid"
              :label="item.name + ' - ' + item.tel"
              :value="item.name + '@' +item.tel">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.tel }}</span>
            </el-option>
          </el-select>
          <el-button :disabled="isDisabledCode" :loading="isCodeLoading" @click="getCode">{{codeBtn}}</el-button>
        </el-form-item>
        <el-form-item label="验证码" prop="code" v-if="offerinfo.balance>0">
          <el-input v-model="editForm.code" maxlength="6" style="width:200px"></el-input><span style="margin-left: 10px;font-size: 12px;color:#99a9bf;">验证码在未验证之前永久有效</span>
        </el-form-item>
        <el-form-item label="备注" prop="content">
          <el-input type="textarea" v-model="editForm.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即结清尾款</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="editPackTitle"
      :visible.sync="editPackVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="editPackForm" :inline="true" :model="editPackForm" label-width="60px">
        <el-form-item label="标签号" prop="packnum">
          <el-input v-model="editPackForm.packnum" maxlength="14" style="width: 130px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="包号" prop="xuhao">
          <el-input type="number" v-model="editPackForm.xuhao" style="width: 80px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchPack" icon="el-icon-search">搜索</el-button>
          <el-button @click="applyPackOut" :loading="fullscreenLoading" icon="el-icon-finished">申请出库</el-button>
        </el-form-item>
      </el-form>
      <div style="padding-bottom: 20px" v-loading="packloading">
        <el-table
          :key="packTableKey"
          :data="packTableData"
          min-height="400"
          @selection-change="handleSelectionChange"
          size="small">
          <el-table-column type="selection" fixed :selectable='checkboxT' align="center" width="50"></el-table-column>
          <el-table-column prop="packnum" fixed align="center" label="包标签号" show-overflow-tooltip min-width="130"></el-table-column>
          <el-table-column prop="xuhao" align="center" label="包号" show-overflow-tooltip width="80"></el-table-column>
          <el-table-column prop="num" align="center" label="部件数量" show-overflow-tooltip width="80"></el-table-column>
          <el-table-column align="center" fixed="right" label="入库状态" show-overflow-tooltip width="80">
            <template slot-scope="props">
              <el-tag :disable-transitions="true" size="mini" v-if="props.row.imark===0" type="danger">未入库</el-tag>
              <el-tag :disable-transitions="true" size="mini" v-if="props.row.imark===1">已入库</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center"  fixed="right" label="出库状态" show-overflow-tooltip width="80">
            <template slot-scope="props">
              <el-tag :disable-transitions="true" size="mini" v-if="props.row.omark===0" type="danger">未出库</el-tag>
              <el-tag :disable-transitions="true" size="mini" v-if="props.row.omark===2" type="warning">待出库</el-tag>
              <el-tag :disable-transitions="true" size="mini" v-if="props.row.omark===1">已出库</el-tag>
            </template>
          </el-table-column>
<!--          <el-table-column align="center" fixed="right" label="部件详细" show-overflow-tooltip width="100">-->
<!--            <template slot-scope="props">-->
<!--              <el-popover-->
<!--                placement="right"-->
<!--                width="500"-->
<!--                trigger="click">-->
<!--                <el-table-->
<!--                  :data="props.row.materialdataList"-->
<!--                  size="mini"-->
<!--                  style="width: 100%">-->
<!--                  <el-table-column prop="barCode" fixed label="条码" show-overflow-tooltip width="130"></el-table-column>-->
<!--                  <el-table-column prop="xuhao" fixed label="序号" show-overflow-tooltip width="70"></el-table-column>-->
<!--                  <el-table-column prop="area" label="区域" show-overflow-tooltip width="100"></el-table-column>-->
<!--                  <el-table-column prop="type" label="分类" show-overflow-tooltip width="80"></el-table-column>-->
<!--                  <el-table-column prop="name" label="名称" show-overflow-tooltip width="130"></el-table-column>-->
<!--                  <el-table-column prop="material" label="基材" show-overflow-tooltip width="80"></el-table-column>-->
<!--                  <el-table-column label="规格" show-overflow-tooltip width="140">-->
<!--                    <template slot-scope="scope">-->
<!--                      <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>-->
<!--                      <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>-->
<!--                      <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>-->
<!--                      <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>-->
<!--                      <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
<!--                  <el-table-column prop="color" label="颜色" show-overflow-tooltip min-width="130"></el-table-column>-->
<!--                </el-table>-->
<!--                <el-button slot="reference" icon="el-icon-link" size="mini">部件</el-button>-->
<!--              </el-popover>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getOutApplyList,
  getErpOrderOfferDetail,
  getDebitSMSCode,
  deductBalance,
  getErpOrderPackList,
  applyOutStock,
  exportOutApplyList
} from '@/api/erp'
import { getFileInfo } from '@/api/pub'
import { getDealerTelList } from '@/api/work'

export default {
  name: 'cksq',
  computed: {
    user: getUser
  },
  data() {
    return {
      exportLoading: false,
      fullscreenLoading: false,
      searchForm: {
        search: '',
        orderType: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editPackTitle: '',
      editPackVisible: false,
      editVisible: false,
      editloading: false,
      isDisabledCode: true,
      isCodeLoading: false,
      codeBtn: '获取验证码',
      codeTimer: '',
      sounds: 60,
      editForm: {
        orderid: '',
        ordername: '',
        content: '',
        offername: '',
        offertime: '',
        offerfile: '',
        offerfileid: '',
        money: null,
        dedutel: '',
        msg_id: '',
        code: '',
        accid: null,
        deposit: 0,
        accamount: 0
      },
      offerinfoLoading: false,
      offerinfo: [],
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }],
        money: [{ required: true, message: '请输入扣款金额', trigger: 'blur' }],
        dedutel: [{ required: true, message: '请选择扣款验证号码', trigger: 'change' }],
        code: [{ required: true, message: '请输入六位短信验证码', trigger: 'blur' }]
      },
      DealerTelList: [],
      packTableData: [],
      packloading: false,
      editPackForm: {
        orderid: '',
        packnum: '',
        xuhao: ''
      },
      multipleSelection: [],
      packTableKey: ''
    }
  },
  created() {
    this.getData()
  },
  watch: {
    'editForm.dedutel': function(newVal) {
      if (newVal !== null && newVal !== '' && newVal !== undefined) {
        if (this.sounds === 60) {
          this.isDisabledCode = false
        }
      } else {
        this.isDisabledCode = true
      }
    }
  },
  methods: {
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          content: this.searchForm.search,
          userid: this.user.dUserid,
          groupid: this.user.dGroupid,
          role: this.user.role,
          orderType: this.searchForm.orderType,
          tableName: '出库申请'
        }
        exportOutApplyList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        orderType: this.searchForm.orderType
      }
      getOutApplyList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({
        path: '/work/order/' + row.order_id.substring(0, 36),
        query: {
          data: row.order_id.substring(37)
        }
      })
    },
    downOffer() {
      getFileInfo({ fileid: this.editForm.offerfileid }).then(response => {
        /* this.$message({
          message: '报价单已下载',
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    getCode() {
      if (this.editForm.dedutel !== null && this.editForm.dedutel !== '' && this.editForm.dedutel !== undefined) {
        if (this.editForm.deposit > 0) {
          if (this.editForm.money !== null && parseFloat(this.editForm.money) > 0) {
            if (parseFloat(this.editForm.money) <= parseFloat(this.editForm.accamount)) {
              if (parseFloat(this.editForm.money) >= parseFloat(this.editForm.deposit)) {
                if (!this.isDisabledCode) {
                  if (this.sounds === 60) {
                    this.isCodeLoading = true
                    const arr = this.editForm.dedutel.split('@')
                    const data = {
                      verifyCode: '1434619f6b1b490fc7b225e6c052abd3',
                      opertype: 1,
                      userid: this.user.dUserid,
                      type: 0,
                      dataid: this.editForm.orderid,
                      amount: this.editForm.money,
                      phoneNum: arr[1],
                      receiver: arr[0]
                    }
                    getDebitSMSCode(data).then(response => {
                      this.editForm.msg_id = response.data
                      this.isCodeLoading = false
                      this.isDisabledCode = true
                      this.codeTimer = setInterval(this.countdown, 1000)
                    }).catch(() => {
                      this.isCodeLoading = false
                    })
                  } else {
                    this.isDisabledCode = true
                  }
                }
              } else {
                this.$message.error('扣款金额至少为 ' + this.editForm.deposit + ' 元')
              }
            } else {
              this.$message.error('账户余额不足')
            }
          } else {
            this.$message.error('请输入扣款金额')
          }
        } else {
          this.$message.error('预付款为0元，无需扣款')
        }
      } else {
        this.$message.error('请选择扣款验证手机号码')
      }
    },
    countdown() {
      this.sounds--
      if (this.sounds === 0) {
        clearInterval(this.codeTimer)
        this.codeBtn = '获取验证码'
        this.isDisabledCode = false
        this.sounds = 60
      } else {
        this.codeBtn = '重新获取 ' + this.sounds
      }
    },
    subsist(row) {
      this.editRules.content[0].required = false
      this.isDisabledCode = true
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.product_num + ' / ' + row.address
      this.editForm.content = ''
      this.editForm.offername = row.offername
      this.editForm.offertime = row.offer_time
      this.editForm.offerfile = row.offer_filename
      this.editForm.offerfileid = row.offer_fileid
      this.offerinfo = []
      this.editForm.money = null
      this.editForm.accid = null
      this.editForm.dedutel = ''
      this.editForm.msg_id = ''
      this.editForm.code = ''
      this.editForm.deposit = 0
      this.editForm.accamount = 0
      this.editVisible = true
      this.offerinfoLoading = true
      getDealerTelList({ delid: row.delid, page: 1, limit: 9999999 }).then(response => {
        this.DealerTelList = response.data
      }).catch(() => {})
      getErpOrderOfferDetail({ orderid: row.order_id }).then(response => {
        this.offerinfo = response.data
        this.editForm.deposit = this.offerinfo.balance
        this.editForm.money = this.editForm.deposit
        this.editForm.accamount = this.offerinfo.accamount
        this.editForm.accid = this.offerinfo.accid
        this.offerinfoLoading = false
      }).catch(() => {
        this.offerinfoLoading = false
      })
    },
    subEdit(formName) {
      this.editRules.content[0].required = false
      this.editRules.money[0].required = true
      this.editRules.dedutel[0].required = true
      this.editRules.code[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.dUserid,
              orderid: this.editForm.orderid,
              remark: this.editForm.content,
              pay: this.editForm.money,
              code: this.editForm.code,
              msg_id: this.editForm.msg_id,
              type: 1
            }
            deductBalance(data).then(response => {
              this.$message({
                message: '订单尾款已结清',
                type: 'success'
              })
              this.editloading = false
              this.editVisible = false
              this.sounds = 60
              if (this.codeTimer !== null && this.codeTimer !== '' && this.codeTimer !== undefined) {
                clearInterval(this.codeTimer)
                this.codeTimer = ''
                this.codeBtn = '获取验证码'
                this.isDisabledCode = true
              }
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    checkboxT(row, rowIndex) {
      if (row.imark === 1 && row.omark === 0) {
        return true
      } else {
        return false
      }
    },
    applyOut(row) {
      if (row.bid === 3) {
        this.editPackTitle = row.order_num + ' 包装详细'
      } else {
        this.editPackTitle = row.product_num + ' 包装详细'
      }
      this.editPackForm.orderid = row.order_id
      this.editPackForm.packnum = ''
      this.editPackForm.xuhao = ''
      this.editPackVisible = true
      this.searchPack()
    },
    searchPack() {
      this.multipleSelection = []
      this.packTableData = []
      this.packloading = true
      const data = {
        orderid: this.editPackForm.orderid,
        packnum: this.editPackForm.packnum,
        xuhao: this.editPackForm.xuhao,
        isall: 1
      }
      getErpOrderPackList(data).then(response => {
        this.packTableKey = new Date().getTime()
        this.packTableData = response.data
        this.packloading = false
      }).catch(() => {
        this.packloading = false
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    applyPackOut() {
      if (!this.fullscreenLoading) {
        if (this.multipleSelection.length > 0) {
          let packIds = []
          for (let p of this.multipleSelection) {
            packIds.push(p.packid)
          }
          this.$confirm('此操作将申请出库此 ' + packIds.length + ' 个包装, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.fullscreenLoading = true
            const data = {
              orderid: this.editPackForm.orderid,
              packIds: packIds.join(','),
              userid: this.user.dUserid
            }
            applyOutStock(data).then(response => {
              this.fullscreenLoading = false
              this.$message({
                message: '申请出库成功',
                type: 'success'
              })
              this.searchPack()
            }).catch(() => {
              this.fullscreenLoading = false
            })
          }).catch(() => {})
        } else {
          this.$message.error('至少选择一个包装进行申请出库')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cksq-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
